import Dataset from 'scoreboard/datasets/model/dataset'
import wrapModel from 'scoreboard/components/wrap-model'
import _ from 'lodash'

/**
 * Returns true if the dataset is not ready for querying
 */
function notReady (dataset) {
	dataset = wrapModel(dataset, Dataset)
	// the dataset won't be defined for calculated dataset widgets
	if (_.isNil(dataset)) return true
	return !dataset.isQueryable()
}

/**
 * Returns true if the dataset and field are not ready for querying; in the case
 * of linked fields, it checks the status of the linked dataset, too
 */
function fieldNotReady (dataset, field) {
	if (notReady(dataset)) {
		return true
	}

	let linkedDataset = dataset.getDatasetForField(field)
	if (linkedDataset && notReady(linkedDataset)) {
		return true
	}

	return false
}

export default notReady
export { fieldNotReady }

notReady.__filename__ = 'dashboards/widgets/dataset-widget-not-ready.js'
